import React from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid"; 
import { PolicyCoverageReadDto } from "../../../model/PolicyCoverageReadDto";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';
import { Cell, Column } from "react-table";
import { formatWithCommas, fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import {CUSTOMER_POLICY_LOBCode as cstPolicyLOBCode} from "../../../../shared/util/constant";

export interface ICustomerPolicyCoverage {
  policyCoverage: PolicyCoverageReadDto[];
  lobCode?: string;
}

const CustomerPolicyCoverage: React.FunctionComponent<ICustomerPolicyCoverage> = (props) => {
  const isEarthquake = Array.isArray(cstPolicyLOBCode.EARTHQUAKE) 
    ? cstPolicyLOBCode.EARTHQUAKE.includes(props.lobCode) 
    : props.lobCode === cstPolicyLOBCode.EARTHQUAKE;

  const columns: any[] = [
    {
      Header: cstPolicyCoverageLabel.BASIC_COVERAGE,
      accessor: "coverageCode",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 400,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.Limit_1,
      accessor: "limit1",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: isEarthquake ? 300 : 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.Limit_2,
      accessor: "limit2",
      Cell: row => <div><span title={row.value}>{formatWithCommas(row.value)}</span></div>,
      width: isEarthquake ? 300 : 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    ...(isEarthquake ? [
      {
        Header: cstPolicyCoverageLabel.EARTHQUAKE,
        accessor: "deductible1",
        Cell: row => <div><span title={row.value}>{row.value}</span></div>,
        width: 380,
        cellClassName:"right-align",
        headerClassName: "right-align-header"
      }
    ] : [
    {
      Header: cstPolicyCoverageLabel.DED_TYPE_AMT1,
      accessor: "dedTypeAmt1",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.DED_TYPE_AMT2,
      accessor: "dedTypeAmt2",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
    {
      Header: cstPolicyCoverageLabel.DED_TYPE_AMT3,
      accessor: "dedTypeAmt3",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    }
  ]),
    {
      Header: cstPolicyCoverageLabel.Premium,
      accessor: "fullTermPremium",
      Cell: row => <div><span title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: isEarthquake ? 260 : 240,
      cellClassName:"right-align",
      headerClassName: "right-align-header"
    },
  ];

  return (
    <PolicyGrid
      data={props.policyCoverage}
      columns={columns}
      gridId="policyCoverageGrid"
      disableSorting = {true}
      sortDefault={[{ id: "coverageCode", asc: true }]}
      noRecordsMessage= {PolicySummaryErrorMessages.NO_COVERAGE_FOUND}
    />
  );
};

export default CustomerPolicyCoverage;
